import PropTypes from 'prop-types';
import React from 'react';
import { scroller } from 'react-scroll';
import { CHOOSE_YOUR_OPTIONS_COMPONENT } from '../../../../config/constants/scroll';
import { GIVE_AS_A_GIFT, GIFT_IT } from '../../../../config/text/text';
import {
  getIsChooseYourOptionsDeal,
  getIsChooseYourProductDeal,
  getIsLeadGen,
  isBookingCalendarChooseDateDeal,
  isBookingCalendarOnRedemptionDeal,
} from '../../../../helpers/deals';
import { useScreenBreakpoint } from '../../../../helpers/screen';
import PrimaryButton from '../../../_generic/button/PrimaryButton';
import DealGiftButton from './DealGiftButton';
import DealViewAvailabilityButton from './DealViewAvailabilityButton';

const MainDealCombinedGiftButton = ({
  deal,
  style,
  buttonRef = undefined,
  className,
  selectedOptions,
  onSetShowMultiError,
  targetScroll,
  isExperienceBox,
  isClaim,
  isGoogleHotel,
  isSoldOut,
  searchParams,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const breakpoint = useScreenBreakpoint();

  if (!deal || !deal.giftable || isClaim) return null;

  const isChooseYourProduct = getIsChooseYourProductDeal(deal);
  const isChooseYourOptions = getIsChooseYourOptionsDeal(deal);
  const isBookingCalendarChooseDate = isBookingCalendarChooseDateDeal(deal);
  const isBookingCalendarOnRedemption = isBookingCalendarOnRedemptionDeal(deal);
  const isLeadGen = getIsLeadGen(deal);

  const toOptionsComponent = () => {
    if (breakpoint === 'sm') {
      onSetShowMultiError(true);
    }
    scroller.scrollTo(targetScroll, {
      delay: 100,
      duration: 1_000,
      offset: breakpoint === 'sm' ? -300 : 0,
      smooth: true,
    });
  };

  if (isLeadGen) {
    return null;
  } else if (isChooseYourProduct) {
    // Go To the Choose your Product panel, inside the deal page

    const hasSelection =
      selectedOptions.reduce(
        (a, b) => Number.parseInt(a) + Number.parseInt(b),
        0,
      ) > 0;

    if (hasSelection) {
      return (
        <>
          <DealGiftButton
            buttonRef={buttonRef}
            className={className}
            deal={deal}
            isSoldOut={isSoldOut}
            position={selectedOptions}
            style={style}
            text={isExperienceBox ? GIFT_IT : GIVE_AS_A_GIFT}
          />
        </>
      );
    } else {
      return (
        <>
          <PrimaryButton
            aria-label={isExperienceBox ? GIFT_IT : GIVE_AS_A_GIFT}
            buttonRef={buttonRef}
            className={`${className}`}
            disabled={isSoldOut}
            onClick={() => {
              toOptionsComponent();
              onSetShowMultiError(true);
            }}
            style={style}
          >
            {isExperienceBox ? GIFT_IT : GIVE_AS_A_GIFT}
          </PrimaryButton>
        </>
      );
    }
  } else if (isChooseYourOptions) {
    // Show the choose your options popup
    return null;
  } else if (isBookingCalendarChooseDate || isBookingCalendarOnRedemption) {
    return (
      <>
        <DealViewAvailabilityButton
          className={className}
          deal={deal}
          gift
          isExperienceBox={isExperienceBox}
          isGoogleHotel={isGoogleHotel}
          searchParams={searchParams}
          style={style}
        />
      </>
    );
  } else {
    return (
      <>
        <DealGiftButton
          buttonRef={buttonRef}
          className={className}
          deal={deal}
          isSoldOut={isSoldOut}
          style={style}
          text={isExperienceBox ? GIFT_IT : GIVE_AS_A_GIFT}
        />
      </>
    );
  }
};

MainDealCombinedGiftButton.propTypes = {
  buttonRef: PropTypes.object,
  className: PropTypes.string,
  deal: PropTypes.object,
  isClaim: PropTypes.bool,
  isExperienceBox: PropTypes.bool,
  isGoogleHotel: PropTypes.bool,
  onSetShowMultiError: PropTypes.func,
  searchParams: PropTypes.object,
  selectedOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  style: PropTypes.object,
  targetScroll: PropTypes.any,
};

MainDealCombinedGiftButton.defaultProps = {
  className: '',
  deal: {},
  isClaim: false,
  isExperienceBox: false,
  onSetShowMultiError: () => {},
  selectedOptions: [],
  style: {},
  targetScroll: CHOOSE_YOUR_OPTIONS_COMPONENT,
};

export default MainDealCombinedGiftButton;
